<template>
  <section>
    <div class="container box mt-5">
      <div class="content mb-6 has-text-centered">
        <h1>Extensión de evaluación académica proceso {{ year }}</h1>
      </div>

      <div class="columns">
        <div class="title is-5">
          Listado de unidades
          <hr class="dropdown-divider" aria-role="menuitem" />
        </div>
      </div>
      <b-table
        :data="units"
        striped
        paginated
        per-page="10"
        :pagination-simple="false"
        pagination-position="bottom"
        aria-next-label="Siguiente"
        aria-previous-label="Anterior"
        aria-page-label="Página"
        aria-current-label="Página actual"
        default-sort-direction="asc"
        default-sort="name"
        sort-icon="arrow-up"
        sort-icon-size="is-small"
      >
        <b-table-column
          field="name"
          label="Nombre de la unidad"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.name }}
        </b-table-column>
        <b-table-column
          field="cost_center"
          label="Centro de costo"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.cost_center }}
        </b-table-column>
        <b-table-column
          label="¿Se extiende el plazo?"
          field="is_extend"
          width="100"
          sortable
          v-slot="props"
        >
          <b-switch
            v-model="props.row.is_extend"
            @input="updateExtend(props.row)"
          >
            {{ props.row.is_extend ? "Sí" : "No" }}
          </b-switch>
        </b-table-column>
      </b-table>
      <b-loading v-model="isLoading" />
    </div>
  </section>
</template>
<script>
import axios from "axios";

export default {
  props: {
    phaseId: {
      type: Number,
      required: true,
    },
    year: {
      type: Number,
      required: true,
    },
    units: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    updateExtend(unit) {
      // Logic to update the extension status of the unit
      this.isLoading = true;
      axios
        .post("/performances/update-extend-phase-term.json", {
          phase_id: this.phaseId,
          unit_id: unit.id,
          is_extend: unit.is_extend,
        })
        .then((response) => {
          this.$buefy.dialog.alert({
            title: "Éxito",
            message: "Extensión de plazo actualizada correctamente.",
            type: "is-success",
            hasIcon: true,
            icon: "check-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .catch((error) => {
          console.error("Error updating extension:", error);
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar actualizar la extensión del plazo.",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
